import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/useUserServicePatchHook";
import useGetHook from "../../customHooks/useUserServiceGetHook";
import Spinner from "../../components/Reusable/Spinner";

const UpdateUserComponent = loadable(
  () => import("../../components/Auth/UpdateUser")
);
const UpdateUser = () => {
  const { id } = useParams()

  const { data, isLoading } = useGetHook({
    queryKey: [`user-${id}`],
    url: `${APIS.USER}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["users"],
    navigateURL: "/users",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.BRANCH}${id}/`;
    let formData = {
      ...values
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { data: roles } = useGetHook({
    queryKey: [`roles`],
    url: APIS.GROUP,
    params: {},
  });

  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit User ({data?.full_name})</span>
      </div>
      {isLoading ? <Spinner />
        :
        <UpdateUserComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          data={data}
          roles={roles}
        />
      }

    </>
  );
};

export default UpdateUser